import _                                  from 'underscore';
import { v4 as uuid }                     from 'uuid'
import { ReactNode, useEffect, useState } from 'react';
import ReactDOM                           from 'react-dom';
import { removeElementsByClass }          from '../util';

type UsePortalHook = ( portalContainerEl: Element, attachPortalToEl: Element ) => [
	portal: Element,
	portalize: ( child: ReactNode ) => React.ReactPortal
]

export const usePortal: UsePortalHook = ( portalContainerEl = null, attachPortalToEl = document.body ) => {
	
	let [ portalClass ]       = useState( `portal-${ uuid() }` ),
	    [ portal, setPortal ] = useState( null );
	
	if( !_.isElement( attachPortalToEl ) ){
		throw new Error( 'Specified portal target / root el to attach to does not exist.' );
	}
	
	useEffect( () => {
		
		// Create portal
		let portal = _.isElement( portalContainerEl ) ? portalContainerEl : document.createElement( 'div' );
		
		portal.classList.add( portalClass );
		
		attachPortalToEl.appendChild( portal );
		
		setPortal( portal );
		
		// On Unmount, remove
		return () => {
			removeElementsByClass( portalClass );
		}
		
	}, [] );
	
	let portalize = ( child: ReactNode ) => ReactDOM.createPortal( child, portal );
	
	return [ portal, portalize ];
};
